<template>
  <b-form
    ref="form"
    novalidate
    :validated="validated">
    <b-form-group>
      <b-checkbox
        v-model="menuItem.enabled"
        :disabled="!canCDMenuEdit"
        switch>
        Enabled
      </b-checkbox>
    </b-form-group>
    <b-form-group
      label="Page"
      description="This should be a known page type that clients know how to render"
      invalid-feedback="Menu page is required">
      <b-input
        v-model="menuItem.page"
        :disabled="!canCDMenuEdit"
        required />
    </b-form-group>
    <b-card
      header="Menu Label"
      class="mb-2">
      <b-form-group
        label="English"
        invalid-feedback="English label is required">
        <b-input
          v-model="menuItem.label"
          :disabled="!canCDMenuEdit"
          required />
      </b-form-group>
      <b-form-group
        label="Spanish"
        invalid-feedback="Spanish label is required">
        <b-input
          v-model="menuItem.labelEs"
          :disabled="!canCDMenuEdit"
          required />
      </b-form-group>
    </b-card>
    <b-form-group label="Display Type">
      <b-radio-group
        v-model="menuItem.displayType"
        :disabled="!canCDMenuEdit"
        required>
        <b-radio value="text">
          Text
        </b-radio>
        <b-radio value="button">
          Button
        </b-radio>
      </b-radio-group>
    </b-form-group>
    <b-form-group label="Selected State">
      <b-radio-group
        v-model="menuItem.selectedState"
        :disabled="!canCDMenuEdit"
        required>
        <b-radio value="underline">
          Underline
        </b-radio>
        <b-radio value="bold">
          Bold
        </b-radio>
        <b-radio value="none">
          None
        </b-radio>
      </b-radio-group>
    </b-form-group>
    <b-form-group label="Hover State">
      <b-radio-group
        v-model="menuItem.hoverState"
        :disabled="!canCDMenuEdit"
        required>
        <b-radio value="pill">
          Pill
        </b-radio>
        <b-radio value="boldhover">
          Bold
        </b-radio>
      </b-radio-group>
    </b-form-group>
    <b-form-group
      label="Qualifying Entitlements"
      description="A list of entitlements that the user should have to see this menu item. Ex: SNY">
      <vue-tags-input
        v-model="qualifyingEntitlement"
        :disabled="!canCDMenuEdit"
        :tags="qualifyingEntitlementTags"
        :add-on-key="[13, 188, ' ']"
        :avoid-adding-duplicates="true"
        placeholder="Add Entitlements (Press enter or space to add multiple entitlements)"
        @before-adding-tag="onBeforeAddingQualifyingEntitlement"
        @tags-changed="onUpdateQualifyingEntitlements" />
    </b-form-group>
    <b-form-group label="Enabled for Devices">
      <div class="pl-2">
        <b-checkbox
          v-model="menuItem.amazon"
          :disabled="!canCDMenuEdit">
          <i class="fab fa-amazon" />
          Amazon
        </b-checkbox>
        <b-checkbox
          v-model="menuItem.android"
          :disabled="!canCDMenuEdit">
          <i class="fab fa-android" />
          Android
        </b-checkbox>
        <b-checkbox
          v-model="menuItem.chromecast"
          :disabled="!canCDMenuEdit">
          <i class="fab fa-chromecast" />
          Chromecast
        </b-checkbox>
        <b-checkbox
          v-model="menuItem.playstation"
          :disabled="!canCDMenuEdit">
          <i class="fab fa-playstation" />
          Playstation
        </b-checkbox>
        <b-checkbox
          v-model="menuItem.roku"
          :disabled="!canCDMenuEdit">
          <i class="fas fa-tv" />
          Roku
        </b-checkbox>
        <b-checkbox
          v-model="menuItem.tvos"
          :disabled="!canCDMenuEdit">
          <i class="fab fa-apple" />
          tvOS
        </b-checkbox>
        <b-checkbox
          v-model="menuItem.xbox"
          :disabled="!canCDMenuEdit">
          <i class="fab fa-xbox" />
          Xbox
        </b-checkbox>
      </div>
    </b-form-group>
  </b-form>
</template>

<script>
import {mapGetters} from "vuex"
import VueTagsInput from "@johmun/vue-tags-input"

export default {
  name: "CDMenuItemForm",
  components: {
    VueTagsInput,
  },
  props: {
    value: {
      type: Object,
      default: () => ({
        enabled: true,
        page: "",
        label: "",
        labelEs: "",
        displayType: "text",
        qualifyingEntitlements: [],
        amazon: false,
        android: false,
        chromecast: false,
        playstation: false,
        roku: false,
        tvos: false,
        xbox: false,
      }),
    },
  },
  data: () => ({
    validated: false,
    qualifyingEntitlement: "",
  }),
  computed: {
    ...mapGetters([
      "canCDMenuEdit",
    ]),
    menuItem: {
      get: function () {
        return this.value
      },
      set: function (value) {
        this.$emit("input", value)
      },
    },
    qualifyingEntitlementTags() {
      return this.menuItem.qualifyingEntitlements ? this.menuItem.qualifyingEntitlements.map(e => ({text: e})) : []
    },
  },
  methods: {
    isValid() {
      this.validated = true
      return this.$refs.form.checkValidity()
    },
    onBeforeAddingQualifyingEntitlement(evt) {
      // Trim any whitespace from the tag before adding it.
      evt.tag.text = evt.tag.text.trim()
      evt.addTag()
    },
    onUpdateQualifyingEntitlements(entitlements) {
      this.$set(this.menuItem, "qualifyingEntitlements", entitlements.map(e => e.text))
    },
  },
}
</script>

<style scoped>

</style>
